export default "__VITE_ASSET__DJaUmBT8__"